import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import AddEmpleado from './AddEmpleado';
import { apiEmpleadosService } from 'services/apiEmpleadosService';
import { useAuth } from 'context/AuthProvider';

const DetalleEmpleado = () => {
    const {empresa} = useAuth();
    const {id} = useParams();
    const [empleado, setEmpleado] = useState(null)
  

    useEffect(() => {
       const fetchData = async () =>{
        const response = await apiEmpleadosService.get(empresa.id, id)
        if(!response.status){}
        setEmpleado(response)
      }
      fetchData();
      return () => {
        setEmpleado(null)
      }
    }, [])

    const handleFiltrar = async (filters) => {
        try {
        
          const response = await apiEmpleadosService.getFiltered(
            empresa.id,
            id,
            filters.centroId,
            filters.departamentoId,
            filters.horarioId
          );
          if (response.status === 200) {
            setEmpleado(response.data); 
          }
        } catch (error) {
          console.error('Error al aplicar filtros:', error);
        }
      };

  return (


    <>  
    {empleado!== null ? <AddEmpleado empleado={empleado} titulo="Detalle empleado"></AddEmpleado> :""}
    
   
    </>
  )
}

export default DetalleEmpleado